<template>
	<div class="layout-component-main">
		<div class="header">
			<h1><span><span>{{ action | capitalize }} </span><slot name="header"></slot></span></h1>
		</div>
		<div class="body">
			<slot></slot>
		</div>
	</div>
</template>

<script>
import capitalize from '@/utils/capitalize'
export default {
	inject: ['$validator'],
	props: [
		'action'
	]
}
</script>



// WEBPACK FOOTER //
// src/components/layouts/LayoutMainForm.vue